/* eslint-disable no-console */

// Defensive kill-switch.
//
// A previous deploy registered a service worker that cached index.html under
// a fixed cache name, leaving users (especially in iOS in-app browsers like
// Instagram) stuck on a stale index.html pointing to JS chunks that no
// longer exist after later deploys — i.e. a blank page on first visit.
//
// Running this on every boot ensures:
//   1. Any service worker still registered on the client gets unregistered.
//   2. Any cache it left behind is cleared.
//
// Both operations are no-ops if nothing is registered, so this is safe to
// keep in place permanently.

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => {
      registrations.forEach((reg) => reg.unregister());
    })
    .catch((err) => {
      console.warn('SW unregister failed:', err);
    });
}

if (typeof window !== 'undefined' && 'caches' in window) {
  caches
    .keys()
    .then((keys) => Promise.all(keys.map((k) => caches.delete(k))))
    .catch((err) => {
      console.warn('Cache cleanup failed:', err);
    });
}
